import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";
import { validatePassword } from "../../../utils/validation";

export const usePasswordSetting = () => {
  const { navigateToPage } = useNavigation();
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("activation_token");
    if (!token) return navigateToPage(PageRoutes.LOGIN);

    dispatch(appActions.showLoading());
    dispatch(
      authActions.checkActivationToken.started({
        activation_token: token,
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: ({ is_valid }) => {
          if (!is_valid) navigateToPage(PageRoutes.LOGIN);
        },
        onError: () => navigateToPage(PageRoutes.LOGIN),
      }),
    );
  }, []);

  const handlePasswordSetting = useCallback(
    (password: string, onError: () => void) => {
      if (!validatePassword(password)) return onError();

      navigateToPage(PageRoutes.PHONE_NUMBER_SETTING, false, {
        token: searchParams.get("activation_token"),
        password,
        isRegistration: true,
      });
    },
    [],
  );

  return { handlePasswordSetting };
};
